import { useTranslations } from '@vocab/react';
import {
  Alert,
  Column,
  Columns,
  Secondary,
  Stack,
  Text,
  Toggle,
} from 'braid-design-system';
import type React from 'react';

import translations from '@seek/rr-caja/src/.vocab';

import { SelectionTypeView } from '../../../sdk';
import type { StatefulRecommendedQuestion } from '../../App/state';
import type { ToggleSelectionTypeViewHandler } from '../Question';

interface Props {
  question: StatefulRecommendedQuestion;
  toggleSelectionTypeView: ToggleSelectionTypeViewHandler;
}

export const SubHeader: React.FC<Props> = ({
  question,
  toggleSelectionTypeView,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="small">
      <Columns space="none" alignY="center">
        <Column>
          <Text size="small">
            <Secondary>
              {t(`question.description.${question.description}`, {
                strong: (
                  children:
                    | boolean
                    | React.ReactChild
                    | React.ReactFragment
                    | React.ReactPortal
                    | null
                    | undefined,
                ) => <strong>{children}</strong>,
              })}
              :
            </Secondary>
          </Text>
        </Column>
        {question.enableSelectionTypeToggle ? (
          <Column>
            <Toggle
              id={`selection-type-toggle-${question.id}`}
              on={question.selectionTypeView === SelectionTypeView.Answers}
              onChange={() => toggleSelectionTypeView(question.id)}
              label={t('question.selectionTypeView.toggle')}
              align="right"
              size="small"
              bleedY
            />
          </Column>
        ) : null}
      </Columns>
      {question.enableSelectionTypeToggle &&
        question.selectionTypeView === SelectionTypeView.Answers && (
          <Alert>
            <Text>{t('question.selectionTypeView.alert')}</Text>
          </Alert>
        )}
    </Stack>
  );
};
